<div class="data-table" [ngStyle]="rootContainerCss">
  <ng-container *ngIf="columns?.length && (isTimeSeries ? timeSeriesFilterIsValid : true); else noMinimalSetup">
    <ng-container *ngIf="data; else noData">
      <div class="data-table__table">
        <ng-container
          *ngIf="isTimeSeries || (canShowGroupOptions && groupByFields?.length > 0); else notTimeSeriesTable"
        >
          <app-time-series-data-table
            [fields]="fields"
            [data]="data"
            [options]="options"
            [selectedColumnNames]="columns"
            [groupByFields]="groupByFields"
            (sortChanged)="sortChanged.emit($event)"
            (columnsChanged)="columnsChanged.emit($event)"
            *ngIf="data?.rows?.length > 0; else noDataFound"
          ></app-time-series-data-table>
        </ng-container>
        <ng-template #notTimeSeriesTable>
          <table
            mat-table
            matSort
            [dataSource]="data.rows"
            (matSortChange)="sortChanged.emit($event)"
            *ngIf="data?.rows?.length > 0; else noDataFound"
            class="table-container"
            cdkDropList
            cdkDropListOrientation="horizontal"
            (cdkDropListDropped)="dropColumns($event)"
          >
            <ng-container *ngIf="hasTotalColumn" matColumnDef="Total">
              <th mat-header-cell *matHeaderCellDef sticky>Total</th>
              <td mat-cell *matCellDef="let row" sticky [class.total-row]="isTotalRow(row)">{{ row['Total'] ?? row[0] }}</td>
            </ng-container>
            <ng-container *ngFor="let column of selectedFields" [matColumnDef]="column.name">
              <th
                mat-header-cell
                [mat-sort-header]="column.meta?.sorting"
                *matHeaderCellDef
                [disabled]="column.meta?.sorting?.includes('.')"
                cdkDrag
                cdkDragBoundary=".table-container"
                cdkDropList
                cdkDragLockAxis="x"
              >
                <div class="drag-handle">
                  <mat-icon [svgIcon]="'drag_indicator'"></mat-icon>
                </div>
                {{ getHeaderLabel(column) }}
              </th>
              <td
                mat-cell
                *matCellDef="let row"
                [matTooltip]="
                  column.meta?.value_hidden
                    ? 'REDACTED'
                    : column.meta?.shapeShifter
                      ? handleShapeShifter(column, row)
                      : (getColumnValue(row, column.name) | readableField: row : column : options)
                "
              >
                @if (column.meta?.value_hidden) {
                  <span class="hidden-field">REDACTED</span>
                } @else {
                  <div *ngIf="column.type === 'textarea'; else plainText" [innerHTML]="row[column.name]"></div>
                  <ng-template #plainText>
                    <ng-container *ngIf="isLinkedFieldColumn(column)">
                      <linkable-related-field-cell
                        [type]="column?.related_to_type"
                        [value]="getLinkedFieldValue(row, column.name)"
                      ></linkable-related-field-cell>
                      <!-- {{ getLinkedFieldValue(row, column.name).label | readableField: row:column:options }} -->
                    </ng-container>
                    <ng-container *ngIf="!isLinkedFieldColumn(column)">
                      <ng-container *ngIf="column.meta?.shapeShifter; else noShapeShifter">
                        {{ handleShapeShifter(column, row) }}
                      </ng-container>
                      <ng-template #noShapeShifter>
                        {{ getColumnValue(row, column.name) | readableField: row : column : options }}
                      </ng-template>
                    </ng-container>
                  </ng-template>
                }
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnDefinitions; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: columnDefinitions" class="row" [class.total-row]="isTotalRow(row)"></tr>
          </table>
        </ng-template>
      </div>
      <div class="data-table__bottom" [class.time-series]="isTimeSeries">
        <div class="data-table__bottom__left">
          <ng-container *ngIf="canShowGroupOptions">
            <app-column-selector
              matTooltip="Group By"
              [items]="groupByFieldsOptions"
              [selectedOrder]="groupByFields | mutateToAny: mutateToFieldArray"
              [draggable]="true"
              [icon]="{ name: 'folder_open', isSvg: false }"
              [position]="position"
              [showCountBadge]="true"
              (onSave)="onSaveColumns($event)"
            >
            </app-column-selector>

            <mat-form-field>
              <mat-label>Summary type</mat-label>
              <mat-select
                [(value)]="summarizeMethod"
                (selectionChange)="summarizeMethodChanged.emit($event.value)"
              >
                <mat-option value="">None</mat-option>
                <mat-option value="SUM">Sum</mat-option>
                <mat-option value="AVG">Average</mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>

          <ng-container *ngIf="isTimeSeries">
            <mat-form-field>
              <mat-label>Cadence</mat-label>
              <mat-select [(value)]="cadence" (selectionChange)="cadenceChanged.emit($event.value)">
                <mat-option value="day">Day</mat-option>
                <mat-option value="month">Month</mat-option>
                <mat-option value="quarter">Quarter</mat-option>
                <mat-option value="year">Year</mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
        </div>
        <div class="data-table__bottom__right">
          <ng-container *ngIf="data.pageInfo as pageInfo">
            <mat-paginator
              [length]="pageInfo.filteredCount"
              [pageIndex]="pageInfo.currentPage - 1"
              [pageSize]="pageInfo.pageSize"
              [pageSizeOptions]="[25, 50, 100]"
              [showFirstLastButtons]="true"
              (page)="pageChanged.emit($event)"
            >
            </mat-paginator>
          </ng-container>
        </div>
      </div>
      <ng-template #noDataFound>
        <ng-container *ngTemplateOutlet="emptyTemplate; context: { $implicit: { type: 'no-rows' } }"></ng-container>
      </ng-template>
    </ng-container>
    <ng-template #noData>
      <ng-container *ngTemplateOutlet="emptyTemplate; context: { $implicit: { type: 'no-data' } }"></ng-container>
    </ng-template>
  </ng-container>
  <ng-template #noMinimalSetup>
    <ng-container
      *ngTemplateOutlet="emptyTemplate; context: { $implicit: { type: 'no-minimal-setup' } }"
    ></ng-container>
  </ng-template>
</div>
<ng-template #emptyTemplate let-params>
  <div class="data-table__empty">
    <mat-icon
      *ngIf="params.type === 'no-rows' || params.type === 'no-minimal-setup'"
      class="data-table__empty__report-icon"
      svgIcon="heroicons_outline:document-report"
    ></mat-icon>
    <div class="data-table__empty__prompt">
      <h4 *ngIf="params.type === 'no-rows'">No data found.</h4>
      <h4 *ngIf="params.type === 'no-minimal-setup'">
        <h4>Start by:</h4>
        <p>
          <mat-icon>{{ columns?.length ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon
          >&nbsp;Select at least one field&nbsp;<a (click)="openSelectField()">here</a>
        </p>
        <ng-container *ngIf="isTimeSeries; else default">
          <p>
            <mat-icon>{{ timeSeriesFilterIsValid ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon
            >&nbsp;Select a start and end date in the filters tab&nbsp;<a (click)="openFiltersTab()">here</a>
          </p>
        </ng-container>
        <ng-template #default></ng-template>
      </h4>
    </div>
  </div>
</ng-template>
